export const APP_DOWNLOAD_COOKIE_KEY = 'appDownloadPSA'
